import React from 'react';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, CircularProgress } from '@mui/material';

import { useLoadingContext } from '@hooks';
import BackDropModal from '@components/BackDropModal';
import { ROUTES } from '@constants';

import { useStyles, useStylesPaper, useStylesIcon } from './styles';

export function AuthLayout({
  children,
  title,
  subTitle,
  open,
  handleClose,
  root,
}) {
  const classes = useStyles();
  const classesPaper = useStylesPaper();
  const classesIcon = useStylesIcon();
  const closeIcon = useStylesIcon();
  const { isLoading, setIsLoading } = useLoadingContext();
  const backdrop = () => <BackDropModal handleClose={handleClose} />;

  return (
    <Modal open={open} BackdropComponent={backdrop}>
      <Paper classes={classesPaper}>
        <Box className={classes.content}>
          {root !== ROUTES.SLIDER_SCREEN ? (
            <Typography classes={closeIcon} onClick={handleClose}>
              No thanks
            </Typography>
          ) : (
            <CloseIcon
              fontSize="large"
              classes={classesIcon}
              onClick={handleClose}
            />
          )}
          <Backdrop
            className={classes.backdrop}
            open={isLoading}
            onClick={() => setIsLoading(false)}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Typography className={classes.title}>{title}</Typography>
          {subTitle && (
            <Typography className={classes.subTitle}>{subTitle}</Typography>
          )}
          <>{children}</>
        </Box>
      </Paper>
    </Modal>
  );
}
